export default "__VITE_ASSET__BWnymgpW__"